import { useEffect } from "react"
import { Outlet } from "react-router-dom"
import { useShellStore } from "./shell.store"
import { SimulatorModal } from "@/features/simulators/SimulatorModal"
import { GuestSession } from "@/components/GuestSession"
import { LoginModal } from "@/components/LoginModal"
import { PaywallModal } from "@/components/PaywallModal"
import { BillingBanners } from "@/features/billing/components/BillingBanners"
import { Toaster } from "@/components/ui/toaster"

/** Full-screen host for the NIRA pages: no AppShell chrome, but the simulator modal still mounts. */
export function NiraFullScreen() {
  const { simulatorService, closeSimulator } = useShellStore()
  // The Nira brand tokens (nira-theme.css, `:root.nira`) apply while these pages are mounted,
  // on <html> so dialogs and toasts portalled to <body> take them too.
  useEffect(() => {
    document.documentElement.classList.add("nira")
    return () => document.documentElement.classList.remove("nira")
  }, [])
  return (
    <>
      <Outlet />
      {simulatorService && <SimulatorModal service={simulatorService} onClose={closeSimulator} />}
      <GuestSession />
      <LoginModal />
      <PaywallModal />
      <BillingBanners />
      <Toaster />
    </>
  )
}
